<template>
  <FeaturesTourDriver
    ref="driver"
    :tour="TOURS_CODES.HELP_CENTER"
    :steps
    :type="TOURS_TYPES.INIT_USER"
    :highlight
    full-width-button
    only-highlight
  />
</template>

<script setup lang="ts">
import type { DriveStep } from 'driver.js'
import FeaturesTourDriver from '~/components/features/tour/Driver.vue'
import { TOURS_CODES, TOURS_TYPES } from '~/constants'

const driver = ref<InstanceType<typeof FeaturesTourDriver> | null>(null)

const steps = computed<DriveStep[]>(() => [])

const highlight = ref<DriveStep>({
  element: '#support-panel',
  popover: {
    title: `Help center`,
    description: `In the Help Center, you'll discover all tours for certain features. Don't hesitate to check out those tours to simplify your work!`,
    showButtons: ['next', 'close'],
    nextBtnText: 'Okay, I’ll check!',
    onNextClick: () => {
      if (driver.value?.driverObj) {
        driver.value.driverObj.destroy()
      }
    },
  },
})
</script>

<style scoped></style>
